import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import ResultStatusTab from 'results/validation/status-tab/ResultStatusTab';
import ResultStatusTabState from 'results/validation/status-tab/ResultStatusTabState';

export class ResultStatusTabView extends Backbone.View<ResultStatusTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab';
  }

  override initialize(): void {
    this.listenTo(this.model.get('model'), 'change', () => {
      this.rerender();
    });
  }

  override render(): this {
    this.rerender();
    return this;
  }

  rerender(): void {
    renderToDOM(<ResultStatusTab entryFile={this.model.get('model')} />, this.el);
  }

  override remove(): Backbone.View<ResultStatusTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ResultStatusTabView.initClass();
